import React from 'react';
import {connect} from 'react-redux';
import {LOGIN_TO} from '~/constant/login';
import LoginFooter from '../../components/LoginFooter';
import LoginForm from '../../components/LoginForm';
import LoginHeader from '../../components/LoginHeader';
import LoginQRCode from '../../components/LoginQRCode';
import ErrorMsg from '../../components/ErrorMsg';
import SwitchTab from './components/SwitchTab';

import './index.less';

// 当前页面是
const TABS = {
    PWD: 0,
    QR: 1
};

const WebLoginModal = props => {
    /* eslint-disable react/prop-types */
    const {
        to,
        isNeedToVerify,
        captchaId,
        phone,
        code,
        errMsg,
        setErrMsg,
        loginFunc,
        agent: {isMobile},
        supportQRCode,
        loginTab: tab,
        onTabChange
    } = props;
    const className = isMobile ? 'h5-login-modal' : 'web-login-modal';
    const isAccountPassword = to === LOGIN_TO.ACCOUNT_PASSWORD;

    return (
        <div className={className}>
            <LoginHeader to={to} />
            {supportQRCode === 1 && isAccountPassword && <SwitchTab tab={tab} onClick={onTabChange} />}
            {tab === TABS.PWD && <ErrorMsg errMsg={errMsg} />}
            {tab === TABS.PWD && (
                <LoginForm
                    params={{to, isNeedToVerify, captchaId, phone, code}}
                    handleLogin={loginFunc}
                    setErrMsg={setErrMsg}
                />
            )}
            {tab === TABS.PWD && (<LoginFooter to={to} />)}
            {tab === TABS.QR && (<LoginQRCode handleLogin={loginFunc} />)}
        </div>
    );
};

export default connect(({agent}) => ({agent}))(WebLoginModal);
